import type { GuardianConsentReceipt } from "../api/contracts";

export const CURRENT_CONSENT_VERSIONS = {
  guardianConsent: "guardian-consent-2026-07-19.v1",
  childPrivacy: "child-privacy-2026-07-19.v1",
  aiTeachingDisclosure: "ai-teaching-disclosure-2026-07-19.v1",
} as const;

export const CONSENT_DOCUMENTS = [
  {
    id: "guardianConsent",
    title: "监护人同意",
    version: CURRENT_CONSENT_VERSIONS.guardianConsent,
    summary: "确认由监护人为孩子建立家庭学习档案并管理学习数据。",
    detail:
      "仅受邀家庭可建立孩子档案。孩子无需邮箱或手机号；监护人负责进入、导出与删除请求。",
  },
  {
    id: "childPrivacy",
    title: "儿童隐私规则",
    version: CURRENT_CONSENT_VERSIONS.childPrivacy,
    summary: "说明收集哪些儿童学习数据、为何使用以及如何管理。",
    detail:
      "产品仅收集课堂所需的称呼、答案、进度和学习证据，不公开孩子记录；正式服务须支持监护人导出、更正与删除。",
  },
  {
    id: "aiTeachingDisclosure",
    title: "AI 辅助授课披露",
    version: CURRENT_CONSENT_VERSIONS.aiTeachingDisclosure,
    summary: "陈老师由 AI 辅助生成讲解、追问和反馈，可能出现错误。",
    detail:
      "系统保留教材引用与核验记录，但 AI 不能替代监护责任；发现数学错误、泄答案或不当内容时应立即暂停课堂。",
  },
] as const;

export type ConsentDocumentId = (typeof CONSENT_DOCUMENTS)[number]["id"];

export function createGuardianConsentReceipt(
  clientAcceptedAt: string,
): GuardianConsentReceipt {
  return {
    guardianConsentVersion: CURRENT_CONSENT_VERSIONS.guardianConsent,
    childPrivacyVersion: CURRENT_CONSENT_VERSIONS.childPrivacy,
    aiTeachingDisclosureVersion:
      CURRENT_CONSENT_VERSIONS.aiTeachingDisclosure,
    clientAcceptedAt,
  };
}

export function hasCurrentConsentVersions(
  receipt: GuardianConsentReceipt,
): boolean {
  return (
    receipt.guardianConsentVersion ===
      CURRENT_CONSENT_VERSIONS.guardianConsent &&
    receipt.childPrivacyVersion === CURRENT_CONSENT_VERSIONS.childPrivacy &&
    receipt.aiTeachingDisclosureVersion ===
      CURRENT_CONSENT_VERSIONS.aiTeachingDisclosure
  );
}
